
            const data = {"name":"add","data":{"width":"17","height":"17","viewBox":"0 0 17 17","data":"<path pid=\"0\" d=\"M8.667 2.742a.667.667 0 0 0-1.334 0v4.666H2.667a.667.667 0 1 0 0 1.334h4.666v4.666a.667.667 0 1 0 1.334 0V8.742h4.666a.667.667 0 1 0 0-1.334H8.667V2.742Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    